<button
  type="button"
  class="campaign__action btn btn--paybee btn--outline-transparent px-2 p-0 noDetaisClick h-100"
  placement="bottom"
  [mdbPopover]="content"
  (popoverShown)="onPopoverShown()"
  (popoverHidden)="onPopoverHidden()"
  #popover="mdbPopover"
  style="border: none; min-width: 38px; height: 30px;"
>
  <i class="fas fa-arrow-down pointer"></i>
  <ng-content></ng-content>
</button>


<ng-template #content >
  <div class="popover-links">
    <div (click)="onDownloadBidSheet(3)" class="popover__action d-flex align-items-center cursor-pointer px-2 py-2 body-1">
      Bid Sheet (PDF)
    </div>
    <div (click)="onDownloadBidSheet(4)" class="popover__action d-flex align-items-center cursor-pointer px-2 py-2 body-1">
      Bid Sheet QR (PDF)
    </div>
  </div>
  </ng-template>